import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'formly-repeat-section',
  templateUrl: './repeat-section.component.html',
  standalone: true,
  imports: [
    ButtonModule,
    FormlyModule,
    CommonModule,
  ]
})
export class RepeatSectionComponent extends FieldArrayType {
  /**
   *
   */
  constructor() {
    super();

  }
}
